<template>
  <div>
    <van-swipe :autoplay="3000" :height="125">
      <van-swipe-item v-if="banners.length==0">
        <a class="banner-a" href="#">
          <img class="banner-img" src="../../assets/Banner.jpg" />
        </a>
      </van-swipe-item> 

      <van-swipe-item v-for="(item, index) in banners" :key="index">
        <a class="banner-a" :href="!item.LinkUrl ? '#' : item.LinkUrl">
          <img class="banner-img" :src="item.UrlAbsolutelPath" />
        </a>
      </van-swipe-item>
    </van-swipe>
    <div class="head-tips">
      <van-notice-bar :text="notice" left-icon="volume-o" />
    </div>

    <div class="nav-page-content">
      <div class="nav-page-title">{{navTitle}}</div>
      <div v-for="(item,index) in lineList" :key="index" class="nav-line"  v-on:click="gotoUrl(item,1)">
        &nbsp; &nbsp; {{item.SchLineAlias?item.SchLineAlias:item.SchLineName}} >>
      </div>
    </div>
     <!-- 我的 -->
    <!--  <div
      v-on:click="gotoUrl(4)"
      :class="'btn-mine '+'theme-'+sysTheme+'-btn'"
    >
      <p
        class="iconfont icon-kehu icon"
      ></p>
      <p
        class="title"
      >
        我的
      </p>
    </div> -->
  </div>
</template>
<script>
import { Swipe, SwipeItem, NoticeBar, Row, Col, Popup, Field } from 'vant'
 //import calendar from 'components/calendar'
 import hotLineList from 'components/hotLineList'
 import sysSettings from 'mixins/settings'

export default {
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [NoticeBar.name]: NoticeBar,
      [Row.name]: Row,
      [Col.name]: Col,
      [Popup.name]: Popup,
      [Field.name]: Field,
     //calendar: calendar,
     [hotLineList.name]: hotLineList
    },
    mixins:[
      sysSettings
    ],
    data() {
      return {
        banners: [],
        notice: '',
        navTitle:'市区到机场',
        lineList:[],//线路列表
      }
    },
    onload: function(options){
      console.log('options--------',options)

    },
    created() {
      //获取系统设置
      this.getSettings().then(setting=>{       
        //设置系统主题
        this.setSysTheme(setting.sysTheme)
        //页面初始化
        this.pageInit(setting)
      })

      this.navTitle = this.$route.query.navname
      this.getLineByGroup();
    },
    methods:{
      //导航跳转
      gotoUrl: function(item,type) {
       let defaultDate = this.$moment().format('YYYY-MM-DD')
       //console.log("item---------",item)
       let node = {
                gid: item.StCode,
                type:1
                //name: data.text.replace(/所有出发站|所有到达地/g,'')
        };
        let endNode ={
            gid:item.SchDstNodeCode,
            type:2
        }
        this.$store.dispatch("setNode", node);
        this.$store.dispatch("setNode", endNode);
          let url=''
          switch (type) {
            case 1:
              url = {
                name: 'classSelect',
                query: this.$utils.getMainUrlParam(2)
              }
              url.query.date = defaultDate;
              url.query.ArrivalNodeGID = this.$store.state.startNode;
              url.query.StartNodeGID = this.$store.state.endNode;
              break;
            }
            this.$router.push(url)
      },
      getLineByGroup(){
        let that =this;
        let params = this.$utils.getMainUrlParam(2)
        params.SchLineGroup =  this.navTitle;
        console.log('params-------',params)
      this.$http
        .post(this.$api.API_ScheLineByGroup, this.$qs.stringify(params))
        .then(res => {
          if (res.success) {
            that.lineList = res.data
            console.log('that.lineList-------',that.lineList)
          }
        })
        .catch(err => {
          console.log(err)
        })
      },
       //页面初始化
       pageInit() {
          let that = this
          //设置广告栏
          that.setBanner()
          //设置主页面标题
          document.title =  that.settings.IndexTitle? that.settings.IndexTitle:'购票'
          //设置通知栏
         that.notice = that.settings.IndexNoteText? that.settings.IndexNoteText: '客流高峰期，客满即发车~_~'
         //that.notice='客流高峰期，客满即发车~_~'
      },
      //设置广告
      setBanner(){
          let that = this
          that.banners = []
          let imgStr = that.settings.HeadImgList
          if (imgStr) {
            let imgjs = eval('('+imgStr+')')
            if(imgjs.length>0){
              imgjs.forEach(function(v) {
                v.UrlAbsolutelPath = v.UrlAbsolutelPath.replace('http:', '')
                that.banners.push(v)
              })
            }
          }
      },
    }
  }
</script>

<style lang="less"  scoped>


.head-tips {
  line-height: 48px;
  background-color: #fff;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  font-size: 16px;
}

.head-tips .van-notice-bar {
  background-color: #fff;
  color: #333;
}
  .banner-a,.banner-img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .nav-page-content{
    background:white;
    width: 100%;
    height: auto;
    margin: 10px auto;

    .nav-page-title{
      background: #e88a1b;
      color: white;
      font-size: 22px;
      height: 45px;
      line-height: 45px;
    }
    .nav-line{
      text-align: left;
      padding-left: 50px;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px dashed black;
    }
  }
  .btn-mine{
  position:fixed;
  bottom: 1rem;
  right: .3rem;
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
  z-index: 30;
  text-align: center;  

   .icon{
 
     text-align: center;
     line-height: .35rem;
     font-size: .35rem;
     margin-top: .2rem;
   }

   .title{
      text-align: center;
      font-size:.22rem;
      line-height: .35rem;
   }
}
</style>

